import { AuthState } from 'slices/modules/auth/authState';
import { RootState } from 'store';

export const authSelector = (state: RootState): AuthState => state.auth;
